function initializePDFGenerator() {
    document.querySelectorAll('.generate-pdf').forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault(); // Prevenir la acción por defecto del enlace
    
        const variantId = link.getAttribute('data-id');
        const noParte = link.getAttribute('data-noParte');
        const productTitle = link.getAttribute('data-title');
        const category = link.getAttribute('data-categoria');
        const material = link.getAttribute('data-material');
        const diagramImage = link.getAttribute('data-drg-image');
        const variantImage = link.getAttribute('data-image');
        const urlPDF = link.getAttribute('data-urlPDF');
        const urlFont = link.getAttribute('data-urlFont');

        createPDF(variantId, noParte, productTitle, category, diagramImage, variantImage, material, urlPDF, urlFont);
      });
    });
  }
  
  async function createPDF(variantId, noParte, productTitle, category, linkDrg, likimg, material, urlPDF, urlFont) {
    try {  
      // Cargar PDF (Plantilla)
      const url = urlPDF;
      const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer());

      // Doc.PDF objeto
      const pdfDoc = await PDFLib.PDFDocument.load(existingPdfBytes);

      // Cargar la funte Fonkit para cargar Funtes al pdfDo c
      // pdfDoc.registerFontkit(window.fontkit);
      
      // // Cargar fuente .ttf
      // const fontURL = await urlFont;
      // const fontBytes = await fetch(fontURL).then(res => res.arrayBuffer());
      
      // // Fuente objeto 
      // const customFont = await pdfDoc.embedFont(fontBytes, { subset: false });ss

      
      // Obtener el No. Parte
      let lstNoParte = noParte.split("|");
      noParte = lstNoParte[0];
      lstNoParte.shift();

      // Obtener las paginas del PDf (array)
      const pages = pdfDoc.getPages();
     
      // Definir objeto y enlasar la pagina del documento PDF
      const txtTexto = pages[0];
      const imgImage = pages[0];
      const tblTable = pages[0];
 
   
      //Texto numero de parte
      txtTexto.drawText(`No. Parte: ${noParte}`, {
        x: 25,
        y: 670,
        size: 13,
        //font: customFont,
        color: PDFLib.rgb(0, 0, 0),
      });

      // Texto categoria del producto
      txtTexto.drawText(`Categoria: ${category}`, {
          x: 400,
          y: 670,
          size: 13,
         // font: customFont,
          color: PDFLib.rgb(0, 0, 0),
      });
      
     
      // Texto titulo del producto
      txtTexto.drawText(`${productTitle}`, {
        x: 25,
        y: 635,
        size: 18,
        //font: customFont,
        color: PDFLib.rgb(0, 0, 0),
      });
      
      // Imagen del Producto(ejemplo con JPG)
      const pngUrl = likimg; // URL de tu imagen
      let img = await fetch(pngUrl); 
      let fotmatImg =  img.headers.get("content-type");
      const pngBytes = await fetch(pngUrl).then(res => res.arrayBuffer());
      const pngImage = fotmatImg == "image/jpeg" ? await pdfDoc.embedJpg(pngBytes) : await pdfDoc.embedPng(pngBytes);    
      
      const pngDims = pngImage.scale(0.3);
      const marginRight =Math.round(( 290 - pngDims.width ) / 2);
      const xStart = 30 + marginRight;
      const marginLeft = Math.round((288 - pngDims.height) / 2);
      const yStart = 350 + marginLeft;
       
      // Imagen del Pruducto
      imgImage.drawImage(pngImage, {
        x: xStart,
        y: yStart,
        width: pngDims.width,
        height: pngDims.height,
      });

      // Imagen del Diagrama del Producto(ejemplo con PNG dfDoc.embedPng)
      const urlDrg = linkDrg; 
      const imgDrg = await fetch(urlDrg); 
      let fotmatImgDrg =  imgDrg.headers.get("content-type");
      const formatBytesImgDrg = await fetch(urlDrg).then(res => res.arrayBuffer());
      const imageDrg = fotmatImgDrg == "image/jpeg" ? await pdfDoc.embedJpg(formatBytesImgDrg) : await pdfDoc.embedPng(formatBytesImgDrg);
      
      const  imageDrgScale = imageDrg.scale(0.26);
      const marginRightDrg =Math.round(( 290 - imageDrgScale.width ) / 2);
      const xStartDrg = 288 + marginRightDrg;
      const marginLeftDrg = Math.round((288 - imageDrgScale.height) / 2);
      const yStartDrg = 370 + marginLeftDrg;

      
      // Imagen del diagrama del producto
      imgImage.drawImage(imageDrg, {
        x: xStartDrg,
        y: yStartDrg,
        width: imageDrgScale.width,
        height: imageDrgScale.height,
      });
      
      // Dibujar marco a la imagen y el dibujo
        const startX = 45;
        const startY = 610;
        const cellWidth = 260;
        const cellHeight = 230;
        const rows = 1;
        const cols = 2;
    
        // Dibujar las celdas de la tabla
      for (let row = 0; row < rows; row++) {
        for (let col = 0; col < cols; col++) {
            const x = startX + col * cellWidth;
            const y = startY - row * cellHeight;

            // Dibujar el borde de la celda
            tblTable.drawRectangle({
            x,
            y: y - cellHeight,
            width: cellWidth,
            height: cellHeight,
            borderColor: PDFLib.rgb(0 / 255, 114 / 255, 189 / 255),
            borderWidth: 2,
            });

        }
      }
      
        
      const cellWidthDrg = 292;
      const startYtable = 426;
      const cellWidthtable = 31;
      const cellHeighttable = 20;
      const rowstable = 2; // Dos filas: una para letras y otra para datos
      const colstable = lstNoParte.length;
      const widthTabla = colstable * cellWidthtable;
      const marginTable = Math.round((cellWidthDrg - widthTabla - colstable + 1) / 2);
      const startXtable = cellWidthDrg + marginTable;


      // Marco de las fotos
      for (let row = 0; row < rowstable; row++) {
        for (let col = 0; col < colstable; col++) {
          const x = startXtable + col * cellWidthtable;
          const y = startYtable - row * cellHeighttable;

          tblTable.drawRectangle({
            x,
            y: y - cellHeighttable,
            width: cellWidthtable,
            height: cellHeighttable,
            borderColor: PDFLib.rgb(0, 0, 0),
            borderWidth: 1,
          });

          // Agregar texto a las celdas   // letras de A - Z
          let text = row === 0 ? String.fromCharCode(65 + col) : lstNoParte[col] || "";
          text = row === 0 && col == colstable - 1 ? "Kg" : text ; // cambia el ultimo dato de la columna en el reglon 0 "Kg"

          txtTexto.drawText(text, {
            x: x + cellWidthtable / 2 - text.length * 3, // Centrando horizontalmente
            y: y - cellHeighttable / 2 - 4, // Centrando verticalmente
            size: 11,
            //font: customFont,
            color: PDFLib.rgb(0, 0, 0),
          });
        }
      }
      
      const titleDatos = ["Nombre: ", "No.Parte: ", "Categoria: ", "Material: ", "Proveedor: "];
      const tableDatos = [productTitle, noParte, category, material, "Aluminadynamics"];
      let ejeY = 340;

      // Crear Tabla la cual contiene las medidas del Diagrama
      for (const key in titleDatos) {
        
        let colorRgb = key  %  2 == 0 ? PDFLib.rgb(148 / 255, 220 / 255, 248 / 255) : PDFLib.rgb(202 / 255, 237 / 255, 251 / 255) ;

        //Agregar Fondo    
        tblTable.drawRectangle({
          x: 45,
          y: ejeY,
          width: 255,
          height: 8,
          borderColor: colorRgb,
          borderWidth: 10,
        });
        
        //Texto numero de parte
        txtTexto.drawText(titleDatos[key], {
          x: 45,
          y: ejeY,
          size: 13,
          //font: customFont,
          color: PDFLib.rgb(0, 0, 0),
        });
        ejeY = ejeY - 20;
      }
      
      // Agregar datos a ala tabla de medias
      let ejeY2 = 340;
      for (const key in tableDatos) {    
        //Texto numero de parte
        txtTexto.drawText(tableDatos[key], {
          x: 125,
          y: ejeY2,
          size: 13,
          //font: customFont,
          color: PDFLib.rgb(0, 0, 0),
        });
        ejeY2 = ejeY2 - 20;
      }

      // Texto de la pagina alumimina URL 
      txtTexto.drawText("www.aluminadynamics.com", {
        x: 12,
        y: 20,
        size: 12,
        //font: customFont,
        color: PDFLib.rgb(1, 1, 1, 1),
      })

      // Texto Email
      txtTexto.drawText("Email: info@aluminadynamics.com", {
        x: 390,
        y: 60,
        size: 12,
       // font: customFont,
        color: PDFLib.rgb(0, 0, 0),
      })
      
      // Texto numero Telefonico
      txtTexto.drawText("Teléfono: (+52) 631 102 7782", {
        x: 390,
        y: 40,
        size: 12,
       // font: customFont,
        color: PDFLib.rgb(0, 0, 0),
      })


      // Guardar el PDF ya modificado
      const pdfBytes = await pdfDoc.save();

      // Crear un blob para el PDF
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const pdfURL = URL.createObjectURL(blob);

      // Agregar el parámetro de zoom a la URL
      const zoomedPdfURL = `${pdfURL}#zoom=80`;

      // Abrir el PDF con el nivel de zoom especificado
      window.open(zoomedPdfURL, '_blank');


    } catch (error) {
      console.error('Error al generar el PDF:', error);
    }
  }

  // Inicializar el generador de PDF cuando el DOM esté listo
  document.addEventListener('DOMContentLoaded', initializePDFGenerator);
  